// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LTILogin_wrapper_2ajP9","invalid":"LTILogin_invalid_3XMvu","image":"LTILogin_image_3aQTm","text":"LTILogin_text_3Ifx3"};